import { useQueryClient } from '@tanstack/react-query'
import { updateConversation } from '../../lib/api'
import { getErrorMessage } from '../../lib/errors'
import { toast } from 'sonner'
import { ConversationSourceControls } from '../content/ConversationSourceControls'

const CHAT_QUERY_KEY = ['chat'] as const

export interface ChatSourceControlsProps {
  conversationId: string
  activeSources?: string[]
}

/**
 * RAG/Research toggles per conversation in the Chat page.
 * Persists to conversation metadata via PATCH and invalidates chat queries.
 */
export function ChatSourceControls({
  conversationId,
  activeSources = [],
}: ChatSourceControlsProps) {
  const queryClient = useQueryClient()

  const handleSave = async (nextActiveSources: string[]) => {
    try {
      await updateConversation(conversationId, {
        active_sources: nextActiveSources,
      })
      queryClient.invalidateQueries({
        queryKey: [...CHAT_QUERY_KEY, 'conversation', conversationId],
      })
      queryClient.invalidateQueries({ queryKey: [...CHAT_QUERY_KEY, 'conversations'] })
      toast.success('Fuentes guardadas')
    } catch (err) {
      toast.error('Error al guardar fuentes', {
        description: getErrorMessage(err),
      })
    }
  }

  return (
    <ConversationSourceControls
      conversationId={conversationId}
      initialActiveSources={
        activeSources.length > 0 ? activeSources : undefined
      }
      onSave={handleSave}
    />
  )
}
